'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/6/27.
                                   */

// import { asyncConnect } from 'redux-async-connect';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersonalCenterChangePassWord = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.userInfo,
    pwdChangeData: state.auth.pwdChangeData
  };
}, authActions), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PersonalCenterChangePassWord, _Component);

  function PersonalCenterChangePassWord() {
    (0, _classCallCheck3.default)(this, PersonalCenterChangePassWord);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalCenterChangePassWord).call(this));
  }

  (0, _createClass3.default)(PersonalCenterChangePassWord, [{
    key: 'onSubmit',
    value: function onSubmit(data) {
      var pwdChangeSubmit = this.props.pwdChangeSubmit;

      if (pwdChangeSubmit) {
        pwdChangeSubmit((0, _extends3.default)({}, data));
      }
    }
  }, {
    key: 'onVerifyClick',
    value: function onVerifyClick(mobile) {
      var getCode = this.props.getCode;

      if (getCode) {
        getCode(mobile);
      }
    }
  }, {
    key: 'onCloseSuccessModal',
    value: function onCloseSuccessModal() {
      var clearPwdChangeData = this.props.clearPwdChangeData;

      if (clearPwdChangeData) {
        clearPwdChangeData();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var user = _props.user;
      var pwdChangeData = _props.pwdChangeData;

      var realUser = user || {};
      var isOpened = false;
      var text = '';
      if (pwdChangeData) {
        isOpened = true;
        if (pwdChangeData.isValid) {
          text = '修改密码成功';
        } else if (pwdChangeData.message) {
          text = pwdChangeData.message;
        }
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.PersonalPasswordChange, { userName: realUser.name,
          getVerifyCode: this.onVerifyClick.bind(this),
          onSubmit: this.onSubmit.bind(this) }),
        _react2.default.createElement(_components.SuccessModal, { isOpened: isOpened,
          width: '400',
          onSubmit: this.onCloseSuccessModal.bind(this),
          text: text })
      );
    }
  }]);
  return PersonalCenterChangePassWord;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func,
  user: _react.PropTypes.object,
  pwdChangeData: _react.PropTypes.object,
  getCode: _react.PropTypes.func,
  clearPwdChangeData: _react.PropTypes.func,
  pwdChangeSubmit: _react.PropTypes.func
}, _temp)) || _class);
exports.default = PersonalCenterChangePassWord;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalCenterChangePassWord/PersonalCenterChangePassWord.js
 ** module id = 1519
 ** module chunks = 0
 **/